import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (p) => !p ? undefined : (p.startsWith("http") ? p : `${BACKEND}${p}`);

export default function ArticleCard({ article, variant = "default" }) {
    if (variant === "large") {
        return (
            <Link to={`/magazine/${article.slug}`} data-testid={`article-card-large-${article.slug}`} className="group block">
                <div className="cp-image-zoom aspect-[16/10] overflow-hidden bg-cp-craie mb-10">
                    <img src={resolveImg(article.cover_image)} alt={article.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
                </div>
                <p className="cp-tiny text-cp-sable-deep mb-5">{article.category} · {article.reading_time} min</p>
                <h2 className="cp-serif text-3xl sm:text-4xl md:text-5xl leading-[1.02] text-cp-encre mb-6 group-hover:italic transition-all">
                    {article.title}
                </h2>
                <p className="cp-serif italic text-xl font-light text-cp-gris leading-snug max-w-3xl">{article.subtitle}</p>
                <p className="cp-link mt-8 inline-block">Lire l'article →</p>
            </Link>
        );
    }
    return (
        <Link to={`/magazine/${article.slug}`} data-testid={`article-card-${article.slug}`} className="group block">
            <div className="cp-image-zoom aspect-[4/5] overflow-hidden bg-cp-craie mb-5">
                <img src={resolveImg(article.cover_image)} alt={article.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
            </div>
            <p className="cp-tiny text-cp-sable-deep mb-2">{article.category} · {article.reading_time} min</p>
            <h3 className="cp-serif text-2xl md:text-3xl leading-[1.05] text-cp-encre group-hover:italic transition-all">{article.title}</h3>
            <p className="cp-serif italic text-base text-cp-gris mt-3 leading-snug max-w-md">{article.subtitle}</p>
        </Link>
    );
}
